import { OverlayRef } from "@angular/cdk/overlay";
import { Subject } from "rxjs";

export class ShowroomShortlistOverlayRef {
  afterClosed$: Subject<void> = new Subject<void>();

  constructor(public overlay: OverlayRef) {}

  close(): void {
    this.overlay.dispose();
    this.afterClosed$.next();
    this.afterClosed$.complete();
  }

  dispose(): void {
    this.overlay.dispose();
    this.afterClosed$.complete();
  }
}
